import Vue from 'vue'
import Vuex from 'vuex'
import general from './modules/general/general'
import flightBooking from './modules/flightBooking/flightBooking'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    general: general,
    fb: flightBooking
  },
  strict: debug
})
